import { render, staticRenderFns } from "./FormPesagem.vue?vue&type=template&id=1f4542ca"
import script from "./FormPesagem.vue?vue&type=script&lang=js"
export * from "./FormPesagem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports